module.exports = __webpack_public_path__ + "static/fullpage-870536bd7ab4fab66d6e379bf55dde41.mp4";